import React from "react";
import {
    Link
} from "react-router-dom";

import Helmet from "../../components/Helmet";
import CallToAction from "../../components/CallToAction";

import banner from "../../img/solar-banner.jpg";
import NavbarSettings from "../../components/navbar/NavbarSettings";
import SubPageBanner from "../../components/SubPageBanner";
import HomepageImageText from "../../components/HomepageImageText";
import MidCallToAction from "../../components/MidCallToAction";

import se48v from "../../img/battery/solaredge-home-battery-48V.png";
import se400v from "../../img/battery/solaredge-home-battery-400V.png";
import aforeAllInOne from "../../img/battery/afore-all-in-1.png";
import solaredgeBatteries from "../../img/producten/solaredge/solaredge-batteries.png";

function Gazetta() {
    return (
        <React.Fragment>
            <Helmet/>

            <NavbarSettings>
                <SubPageBanner
                    title="Thuisbatterij"
                    subtitle="Maximaliseer je zonverbruik"
                    image={ banner }
                />
            </NavbarSettings>

            <div className="container-orange-background">
                <div className="container">
                    <h2 className="text-center"> Verlaag je energierekening met een thuisbatterij</h2>
                    <HomepageImageText
                        text={
                            <>
                                <p>Steeds meer mensen kiezen voor een thuisbatterij. Dit is een goede keuze omdat:</p>
                                <ul className="list-unstyled">
                                    <li className="mb-2"><i className="fa fa-check-circle"></i> Je kunt het gebruik van <strong>eigen opgewekte energie maximaliseren</strong></li>
                                    <li className="mb-2"><i className="fa fa-check-circle"></i> Je bent <strong>minder afhankelijk</strong> van de stroomleverancier of de zonne-opbrengst</li>
                                    <li className="mb-2"><i className="fa fa-check-circle"></i> Een thuisbatterij is een goede investering voor <strong>de toekomst</strong></li>
                                </ul>
                                <p>
                                    <b>Gratis advies:</b> Vraag een offerte aan en krijg gratis advies op maat.
                                </p>
                                <p>
                                    <b>12 jaar expertise:</b> Met onze jarenlange ervaring in de zonne-energie branche kunnen wij u helpen bij het kiezen van de juiste thuisbatterij.
                                </p>
                            </>
                        }
                        img={solaredgeBatteries}
                        imgAlt="Foto van solaredge batterijen"
                        underLinedTitle={false}
                        buttonLink="/offerte/"
                        buttonText="Offerte aanvragen"
                    />
                </div>
            </div>


            <div className="container container-sm pt-4">

                <h3 className="text-center" style={{ fontSize: "2rem" }}>
                    Wat zijn de voordelen van een thuisbatterij?
                </h3>
                <p>
                    Er zijn een aantal voordelen om nu al een thuisbatterij te halen:
                </p>
                <ul>
                    <li className="mb-2">
                        <b>Duurzaamheid. </b>
                        Door een thuisbatterij bij u thuis te plaatsen wordt uw energieverbruik een stuk duurzamer.
                        Waar u met alleen zonnepanelen 's avonds en 's nachts grijze energie van vervuilende
                        centrales gebruikt, zullen deze met een thuisbatterij worden gevoed met uw eigen groene zonnestroom!
                        Daarnaast helpt u mee het energienet te balanceren wat toedraagt aan de energietransitie voor een schoner klimaat.
                    </li>
                    <li className="mb-2">
                        <b>Onafhankelijkheid. </b>
                        Met een thuisbatterij wordt u nog minder afhankelijk van het energienet dat met alleen
                        zonnepanelen. U bent ongeveer 30% onafhankelijk met alleen zonnepanelen. Dit stijgt naar ongeveer
                        70% als u daar een thuisbatterij aan toevoegt! U heeft dan nauwelijks meer last van stijgende
                        energieprijzen.
                    </li>
                    <li className="mb-2">
                        <b>Voorbereid. </b>
                        In de komende jaren zal de salderingsregeling afgeschaft worden. Dit heeft tot gevolg dat u extra
                        opgewekte stroom dat wordt teruggeleverd niet meer vergoed zal krijgen. Door een thuisbatterij
                        aan uw installatie toe te voegen zal u deze extra opgewekte stroom alsnog zelf kunnen gebruiken.
                    </li>
                    <li className="mb-2">
                        <b>Noodgevallen. </b>
                        Er zijn ook mogelijkheden om de thuisbatterij als backupstroom te gebruiken. Als er een stroomstoring
                        plaatsvindt in het energienet kunt u uw apparaten verder voeden op de opgeslagen energie uit uw
                        thuisbatterij. Nou is het energienet in Nederland erg stabiel, maar je bent blij met de investering
                        als het wel een keer gebeurt. Vraag ons naar de mogelijkheden!
                    </li>
                    <li className="mb-2">
                        <b>Waardestijging. </b>
                        Een woning met zonnepanelen en een thuisbatterij wordt gezien als een waardevolle
                        investering en kan de waarde van de woning verhogen. Dit komt doordat potentiële kopers
                        geïnteresseerd zijn in duurzame en energiezuinige woningen. Door te investeren in een
                        thuisbatterij, investeer je dus niet alleen in je eigen huis, maar ook in de waarde ervan voor
                        de toekomst.
                    </li>
                </ul>
            </div>

            <div className="container">
                <MidCallToAction/>
            </div>

            <div className="container">

                <h3 className="text-center" style={{ fontSize: "2rem" }}>
                    Ons aanbod
                </h3>
                <HomepageImageText
                    title="SolarEdge Home Battery 400V"
                    titleTag="h4"
                    text={
                        <>
                            <ul>
                                <li> Ondersteuning 1-fase SolarEdge omvormers </li>
                                <li> Uitbreiden van 10 kWh tot 30 kWh per omvormer </li>
                                <li> Kan tot 50 meter van de omvormer vandaan geplaatst worden </li>
                                <li> Kan ook buiten geplaatst worden (schaduw, onder afdakje) </li>
                                <li> Kan op reguliere SolarEdge HD-Wave omvormers aangesloten worden </li>
                                <li> Efficiëntie van 94,5% </li>
                                <li> Voldoet aan de strengste veiligheidseisen </li>
                                <li> 10 jaar garantie </li>
                            </ul>
                            <Link to="/offerte/" className="btn btn-primary"> Offerte aanvragen </Link>
                        </>
                    }
                    img={se400v}
                    imgAlt="Foto van SolarEdge Home Battery 400V"
                    underLinedTitle
                    coverImage={true}
                />

                <HomepageImageText
                    title="SolarEdge Home Battery 48V"
                    titleTag="h4"
                    text={
                        <>
                            <ul>
                                <li> Ondersteuning 3-fase SolarEdge omvormers </li>
                                <li> Uitbreiden van 4,6 kWh tot 23 kWh per omvormer </li>
                                <li> Modulair uitgevoerd, dus kan op zolder geïnstalleerd worden </li>
                                <li> Efficiëntie van 95,4% </li>
                                <li> Voldoet aan de strengste veiligheidseisen </li>
                                <li> 10 jaar garantie </li>
                            </ul>
                            <Link to="/offerte/" className="btn btn-primary"> Offerte aanvragen </Link>
                        </>
                    }
                    img={se48v}
                    imgAlt="Foto van SolarEdge Home Battery 48V"
                    coverImage={true}
                    underLinedTitle
                />

                <HomepageImageText
                    title="Afore All-in-One"
                    titleTag="h4"
                    text={
                        <>
                            <ul>
                                <li> Ondersteuning 1-fase omvormers </li>
                                <li> Efficiëntie van (meer dan) 97% </li>
                                <li> Uitbreiden van 5.1 kWh tot 30.7 kWh per omvormer </li>
                                <li> Modulair uitgevoerd, dus kan op zolder geïnstalleerd worden </li>
                                <li> IP66 waterdicht, kan buiten geplaatst worden </li>
                                <li> Voldoet aan strenge veiligheidseisen </li>
                                <li> 10 jaar garantie </li>
                            </ul>
                            <Link to="/offerte/" className="btn btn-primary"> Offerte aanvragen </Link>
                        </>
                    }
                    img={aforeAllInOne}
                    imgAlt="Foto van Afore All-in-One"
                    underLinedTitle
                />
            </div>


            <CallToAction title={
                <React.Fragment>
                    <small className="text-muted">
                        Bent u er klaar voor?
                    </small>
                    <br/>
                    Vraag vandaag nog een offerte aan!
                </React.Fragment>
            }/>
        </React.Fragment>
    )
}

export default Gazetta;
